import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import axios from "axios";

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    company: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Send form data to your backend
      const response = await axios.post(
  "/api/contact",
        formData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.success) {
        alert("✅ Thank you for your message! We will get back to you soon.");

        // Clear form
        setFormData({
          name: "",
          email: "",
          phone: "",
          company: "",
          message: "",
        });
      }
    } catch (error) {
      console.error("Error submitting form:", error);

      // Show backend error message
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        alert(`❌ ${error.response.data.message}`);
      } else {
        alert("❌ Something went wrong. Please try again later.");
      }
    }
  };

  return (
    <div id="main-wrapper">
      <Header />
      <div id="content" role="main">
        {/* Hero Section */}
        <section
          className="hero-wrap"
          style={{
            position: "relative",
            overflow: "hidden",
            minHeight: "60vh",
            display: "flex",
            alignItems: "center",
            background: "rgba(0,0,0,0.4)",
            backgroundImage: "url('/images/projects/contact-h.png')",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        >
          <div
            className="container"
            style={{ position: "relative", zIndex: 2, paddingTop: "70px" }}
          >
            <div className="row">
              <div className="col-12 text-center text-white">
                <h1 className="text-16 font-weight-600 mb-3 text-white">
                  Contact Us
                </h1>
                <p className="lead text-white mb-0">Begin Your Transformation</p>
              </div>
            </div>
          </div>

          <div
            style={{
              position: "absolute",
              inset: 0,
              background: "rgba(0, 0, 0, 0.4)",
              zIndex: 1,
            }}
          ></div>
        </section>

        {/* Contact Form */}
        <section className="section bg-white">
          <div className="container">
            <div className="row">
              {/* Form */}
              <div className="col-lg-8 mb-5 mb-lg-0">
                <div className="bg-light p-5 rounded shadow-sm">
                  <h3 className="font-weight-600 mb-4">Send Us a Message</h3>

                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="name"> Name *</label>
                          <input
                            type="text"
                            className="form-control"
                            id="name"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                            placeholder="John Doe"
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="email">Email Address *</label>
                          <input
                            type="email"
                            className="form-control"
                            id="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                            placeholder="john@example.com"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="phone">Phone Number</label>
                          <input
                            type="tel"
                            className="form-control"
                            id="phone"
                            name="phone"
                            value={formData.phone}
                            onChange={handleChange}
                            placeholder="+91 12345 67890"
                          />
                        </div>
                      </div>

                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="company">Company Name</label>
                          <input
                            type="text"
                            className="form-control"
                            id="company"
                            name="company"
                            value={formData.company}
                            onChange={handleChange}
                            placeholder="Your Company"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="form-group">
                      <label htmlFor="message">Message *</label>
                      <textarea
                        className="form-control"
                        id="message"
                        name="message"
                        rows="6"
                        value={formData.message}
                        onChange={handleChange}
                        required
                        placeholder="Tell us more about your project..."
                      ></textarea>
                    </div>

                    <button
                      type="submit"
                      className="btn btn-primary btn-lg rounded-pill px-5"
                    >
                      Send Message
                    </button>
                  </form>
                </div>
              </div>

              {/* Contact Details */}
              <div className="col-lg-4">
                <div className="mb-4">
                  <h4 className="font-weight-600 mb-3 ">Get In Touch</h4>
                  <p className="text-3">
                    We're here to help and answer any question you might have.
                  </p>
                </div>

                {/* Address */}
                <div className="mb-4 d-flex">
                  <i className="fas fa-map-marker-alt fa-2x text-primary mr-3"></i>
                  <div>
                    <h6 className="font-weight-600">Corporate Office</h6>
                    <p className="text-3 mb-0">
                      718, Tower-1, Assotech Business Cresterra <br />
                      Sector-135, Noida, Uttar Pradesh - 201301
                    </p>
                  </div>
                </div>

                {/* Phone */}
                <div className="mb-4 d-flex">
                  <i className="fas fa-phone-alt fa-2x text-primary mr-3"></i>
                  <div>
                    <h6 className="font-weight-600">Call Us</h6>

                    <p className="mb-0">
                      <a href="tel:+918877777475" className="text-3">
                        +91 88777 77475
                      </a>
                    </p>
                  </div>
                </div>

                {/* Email */}
                <div className="mb-4 d-flex">
                  <i className="fas fa-envelope fa-2x text-primary mr-3"></i>
                  <div>
                    <h6 className="font-weight-600">Email Us</h6>
                    <p className="mb-0">
                      <a
                        href="mailto:info@rovoautomation.com"
                        className="text-3"
                      >
                        info@rovoautomation.com
                      </a>
                    </p>
                  </div>
                </div>

                {/* Hours */}
                <div className="mb-4 d-flex">
                  <i className="fas fa-clock fa-2x text-primary mr-3"></i>
                  <div>
                    <h6 className="font-weight-600">Business Hours</h6>
                    <p className="text-3 mb-0">
                      Monday - Friday: 9:00 AM - 6:00 PM <br />
                      Saturday: 9:00 AM - 1:00 PM <br />
                      Sunday: Closed
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Google Map Section */}
        <section className="bg-light py-0 !mb-20">
          <div className="container-fluid p-0">
            <iframe
              src="https://www.google.com/maps?q=Assotech%20Business%20Cresterra%20Sector%20135%20Noida&output=embed"
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Office Location"
            />
          </div>
        </section>

        {/* CTA Section */}
        <section
          className="section text-white !mt-24 !py-20"
          style={{
            backgroundImage: "url('/images/projects/ContactF.png')",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="container ">
            <div className="row align-items-center">
              <div className="col-lg-8 mb-4 text-center text-lg-left">
                <h3 className="font-weight-700 mb-2 text-white">
                  Let's turn your ideas into reality.
                </h3>
                <p
                  className="lead mb-0  font-weight-400 "
                  style={{ color: "#f1f1f4ff" }}
                >
                  contact us to collaborate.
                </p>
              </div>

              <div className="col-lg-4 text-center text-lg-right">
                <a
                  href="tel:+918535077757"
                  className="btn btn-light btn-lg rounded-pill"
                >
                  <i className="fa-solid fa-phone mr-2"></i>Call Now
                </a>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default ContactPage;
